export const DalyaRecommendationTypes = {
  PA_DIGITAL: 'Encaminhamento para PA Digital',
  PS: 'Encaminhamento para Pronto Socorro',
  APS: 'Encaminhamento para Atenção Primária',
  SPECIALIST: 'Encaminhamento para Especialista',
  UNKNOWN: 'Nenhuma conduta recomendada',
  CIAP_NOT_FOUND: 'Nenhuma conduta recomendada'
}
